import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Modal,
  Row,
  Col,
  Card,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import { useHistory } from "react-router";
import Context from "../Context";

export default ({
  changedCsl,
  active_csl,
  imported_csls,
  set_imported_csls,
}) => {
  const context = useContext(Context);
  const history = useHistory();
  const [show, set_show] = useState(false);
  const [csl_count, set_csl_count] = useState(0);
  const [query, set_query] = useState("");

  const [csls, set_csls] = useState([]);
  const [loading_csls, set_loading_csls] = useState(false);

  const loadDefaultCsls = () => {
    if (imported_csls.length > 0) return;
    set_loading_csls(true);
    context.ApiDriver.getBaseCsls(
      {},
      (response) => {
        set_csls(response);
        set_loading_csls(false);

        context.ApiDriver.getCsls(
          {},
          (response) => {
            set_csls(response);
            set_csl_count(response.meta.total);
          },
          (error) => {}
        );
      },
      (error) => {
        set_loading_csls(false);
      }
    );
  };
  useEffect(loadDefaultCsls, []);

  const loadCsls = () => {
    set_loading_csls(true);
    context.ApiDriver.getCsls(
      { query },
      (response) => {
        set_csls(response.data);
        set_csl_count(response.meta.total);
        set_loading_csls(false);
      },
      (error) => {
        set_loading_csls(false);
      }
    );
  };
  // useEffect(() => {
  //   loadCsls();
  // }, [loadCsls]);

  const handleClose = () => {
    set_show(false);
  };
  const handleShow = () => {
    set_show(true);
  };
  const handleChange = (e) => {
    let value = e.target.value;
    value = value.replace("ي", "ی");
    value = value.replace("ك", "ک");
    set_query(value);
    loadCsls();
  };
  const open_csl_order = () => {
    history.push("/csl-order");
  };
  const renderCSls = () => {
    if (csls.length > 0) {
      return csls.map((item, index) => {
        let added = false;
        for (let i = 0; i < (imported_csls || []).length; i++)
          if (imported_csls[i].id === item.id) added = true;
        return (
          <Col md={12} key={index}>
            <Card
              className="cite__csl-row-Card"
              style={added ? { background: "#EEE" } : {}}
            >
              <Card.Body
                className="cite__csl-row-body"
                style={!item.rtl ? { direction: "ltr", textAlign: "left" } : {}}
              >
                <Row style={{ marginTop: 0 }}>
                  <Col md={2} sm={2} style={{ textAlign: "left" }}>
                    {item.status === 1 ? (
                      added ? (
                        <Button
                          block
                          disabled={imported_csls.length < 2}
                          onClick={() => {
                            rejectCSL(item.id);
                          }}
                          variant="danger"
                        >
                          حذف
                        </Button>
                      ) : (
                        <Button
                          block
                          onClick={() => {
                            importCSL(item);
                          }}
                        >
                          افزودن
                        </Button>
                      )
                    ) : (
                      <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                          <Tooltip>
                            این شیوه‌نامه در نسخه آنلاین فعال نمی‌باشد. لطفا
                            نسخه دسکتاپی پژوهیار را خریداری نمایید.
                          </Tooltip>
                        }
                      >
                        <Button variant="outline-secondary" block>
                          افزودن
                        </Button>
                      </OverlayTrigger>
                    )}
                  </Col>
                  <Col
                    md={10}
                    sm={10}
                    style={{ lineHeight: "35px", direction: "rtl" }}
                  >
                    {item.title_fa}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        );
      });
    } else {
      return (
        <Col md={12}>
          <Card className="cite__csl-row-Card">
            <Card.Body className="cite__csl-row-body">
              <Row style={{ marginTop: 0 }}>
                <Col md={12} style={{ direction: "rtl", textAlign: "center" }}>
                  شیوه‌نامه مورد نظر پیدا نشد.
                </Col>
                <Col md={12} style={{ textAlign: "center", marginTop: 15 }}>
                  <Button variant="info" onClick={open_csl_order}>
                    سفارش شیوه
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      );
    }
  };
  const rejectCSL = (csl_id) => {
    set_imported_csls(
      imported_csls.filter((csl) => (csl.id === csl_id ? null : csl))
    );
    context.cookie.set(
      "imported_csls",
      imported_csls.filter((csl) => (csl.id === csl_id ? null : csl))
    );
    // () => {
    //   let found_csl_in_imported = -1;
    //   for (let i = 0; i < imported_csls; i++) {
    //     if (imported_csls[i].id === active_csl) {
    //       found_csl_in_imported = i;
    //     }
    //   }
    //   if (!found_csl_in_imported) {
    //     chooseCSL(0, () => {});
    //   }
    // }
    // );
  };
  const importCSL = (item) => {
    set_imported_csls(imported_csls.concat([item]));
  };
  const handleChangeCsl = (e) => {
    const value = e.value;
    if (value === "MORE") {
      handleShow();
    } else {
      chooseCSL(e.value);
    }
  };
  const chooseCSL = (id) => {
    changedCsl(
      imported_csls.filter((csl) => (csl.id === id ? csl : null)).pop()
    );
  };
  return (
    <div>
      <Row style={{ marginBottom: 10 }}>
        <Col md={12}>
          <Select
            id="csl-select"
            styles={{
              option: (provided, state) => {
                let background = "#FFF";
                let color = "#000";
                if (state.data.more) {
                  background = "#EEE";
                  color = "#333";
                } else if (state.isDisabled) {
                  background = "#EEE";
                  color = "#888";
                } else if (state.isSelected) {
                  background = "#48a4b3";
                  color = "#FFF";
                } else if (state.isFocused) {
                  background = "#EEF";
                  color = "#000";
                }
                return {
                  ...provided,
                  background,
                  color,
                };
              },
            }}
            isLoading={loading_csls}
            placeholder="انتخاب کنید ..."
            onChange={handleChangeCsl}
            isRtl={true}
            value={
              active_csl
                ? {
                    value: active_csl.id,
                    label: active_csl.title_fa,
                    more: false,
                  }
                : null
            }
            isSearchable={true}
            options={imported_csls
              .map((item, index) => {
                return {
                  value: item.id,
                  label: item.title_fa,
                  more: false,
                };
              })
              .concat({
                value: "MORE",
                label: `جستجو در ${csl_count} شیوه‌نامه...`,
                more: true,
              })}
          />
        </Col>
      </Row>
      <Modal
        size="lg"
        show={show}
        style={{ zIndex: 9999 }}
        onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>جستجو در شیوه‌نامه‌ها</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Control
              type="text"
              className="text-right cite__inp"
              defaultValue={query}
              placeholder="عنوان شیوه‌نامه"
              onChange={handleChange}
            />
          </Form.Group>
          <Row>{renderCSls()}</Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};
